module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAUBAMAAADxfUlCAAAAFVBMVEUANYALPoUYSIwnVJNHbaNXeqv///8I7wDgAAAAKElEQVQY02NIA4JkBoawNChIYKCniAsQODIwqLhAgQMDtQCmyQPqUwAp7Vn5a34wrAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/fi.png
// module id = 822
// module chunks = 0